<!-- template v.1 -->
<template>
<div class="col py-3">
            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Registro de Horarios </h4>
    
            </div>
             <div class="col-md-12" style="padding:0;margin-bottom:15px">
                <div class="card card-info">
                    <div class="card-header">
                        <h3 class="card-title">Datos Generales</h3>
                        
                    </div>
                <div class="card-body" style="padding-top:0px">
                    <div class="col-md-4 form-org">
                        <div class="input-group">
                            <label class="col-form-label"  style="width: 100%;">
                            Nombre
                            </label>
                            <input type="text" class="form-control" maxlength="50" v-model="NombreRegistro" placeholder="Nombre" required >
                        </div>
                    </div>
                    <div class="col-md-4 form-org">
                        <div class="form-group ">
                            <label class="col-form-label" >
                                Turno</label
                            >
                            <select class="form-control"    v-model="TurnosRegistro">
                                <option value="-1" >Todos </option>
                                <option v-for="item in ListaTurnos" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                                
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4 form-org">
                        <div class="input-group">
                            <label class="col-form-label"  style="width: 100%;">
                            Tolerancia Ing. (min)
                            </label>
                            <input type="number" class="form-control" v-model="ToleranciaRegistro" placeholder="Escriba un número" required
                                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                    maxlength = "6"
                            >
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Entradas y Salidas</h3>
                
              </div>
                <div class="card-body" style="padding-top:0px">
                <div class="col-md-12">
                    <div class="col-md-4 form-org">
                        <div class="input-group">
                            <label class="col-form-label"  style="width: 100%;">
                            Hora Ingreso
                            </label>
                            <input type="time" v-model="HoraIngresoRegistro" class="form-control"  required>
                        </div>
                    </div>
                    <div class="col-md-4 form-org">
                        <div class="form-group ">
                            <label class="col-form-label" >
                                Hora Salida</label>
                            <input type="time" v-model="HoraSalidaRegistro" class="form-control" required >
                        </div>
                    </div>
                    <div class="col-md-4 form-org">
                        <div class="input-group">
                            <label class="col-form-label"  style="width: 100%;">
                            Duración Regriferio (min)
                            </label>
                            <input type="number" class="form-control" v-model="RefrigerioRegistro" placeholder="Escriba un número" max="120" required
                              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                              maxlength = "6"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="col-md-12 form-org">
                        <label class="col-form-label"  style="width: 100%;">
                            <b>Aplicar los días </b>
                        </label>
                    </div>
                    <div class="col-md-4 form-org">
                    
                        <label for="Lunes"><input id="Lunes" type="checkbox" v-model="CheckLunes"  > Lunes</label><br>
                        <label for="Martes"><input type="checkbox" v-model="CheckMartes"  > Martes</label><br>
                        <label for="Miercoles"><input type="checkbox" v-model="CheckMiercoles"  > Miércoles</label><br>
                        <label for="Jueves"><input type="checkbox" v-model="CheckJueves"  > Jueves</label>
                    </div>
                    <div class="col-md-4 form-org">
                        <label for="Viernes"><input type="checkbox" v-model="CheckViernes" > Viernes</label><br>
                        <label for="Sabado"><input type="checkbox" v-model="CheckSabado"  > Sábado</label><br>
                        <label for="Domingo"><input type="checkbox" v-model="CheckDomingo" > Domingo</label>
                    </div>

                    <div class="col-md-4 form-org">
                    <div class="input-group" style="margin-top:25px">
                            <button type="submit" 
                            class="btn btn-success" 
                            style="width:100%" 
                            @click="Agregar()" >
                            
                            Agregar</button>
                            </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="col-md-12 form-org" style="margin-top:15px">
        
        
         <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th >Horario Ingreso</th>
                      <th >Horario Salida</th>
                      <th >Duración Refrigerio</th>
                      <th >Días</th>
                      <th >Regriferio</th>
                      <th >Quitar</th>

                   
                     
                    </tr>
                  </thead>
                  
                   <tbody v-for="(item, index) in Horarios"   v-bind:key="item" v-bind:index="index" >
                    <tr >
                      <td >{{item.HoraIngreso}}</td>
                      <td >{{item.HoraSalida}}</td>
                      <td >{{item.Refrigerio}}</td>
                      <td ><div v-if="item.Lunes == 1" style="float:left">Lu. </div>
                           <div v-if="item.Martes == 1" style="float:left">Ma. </div>
                           <div v-if="item.Miercoles == 1" style="float:left">Mi. </div>
                           <div v-if="item.Jueves == 1" style="float:left">Ju. </div>
                           <div v-if="item.Viernes == 1" style="float:left">Vi. </div>
                           <div v-if="item.Sabado == 1" style="float:left">Sa. </div>
                           <div v-if="item.Domingo == 1" style="float:left">Do. </div>

                      
                      </td>
                      <td >
                        <button type="button" class="btn btn-info btn-table" @click="AgregarRegistro(item)">Agregar</button>
                        <button type="button" class="btn btn-info btn-table" @click="VerRegistro(item , Horarios)">Ver</button>
                       </td>
                      <td >
                          <button type="button" @click="Quitar(item, Horarios)" 
                          style="margin-left:5px;background: none;border: none;" ><i class="fas fa-times" style="color:red"></i></button>
                      </td>
                      

                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
               
        </div>
        <div class="col-md-12" >
            <button type="button" class="btn btn-success guardar-modal" @click="Guardar()" >Guardar</button>
        <router-link to="/busqueda-horarios"><button type="button" class="btn btn-danger cancelar-modal" > Cancelar</button></router-link>
        </div>
        </div>

    <ModalPeque v-show="ModalPeque.isEliminarHorarios" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group" style="text-align: center;">
            <label class="col-form-label" > ¿Está seguro de eliminar la marcación? </label>
        </div>
        
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EliminarHorarios()" >Aceptar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isEliminarHorarios = false"> Cancelar</button>
      </div>
    </div>
   
</ModalPeque> 
<ModalPeque v-show="ModalPeque.isNuevoHorario" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group">
            <label class="col-form-label"> Nombre del Grupo </label>
                <input type="text" maxlength="50" v-model="NombreGrupo" class="form-control"  >
        </div>
        <div class="form-group">
            <label class="col-form-label"> Inicio Refrigerio </label>
                <input type="time" v-model="InicioRefrigerio" class="form-control" v-bind:max="horainiciomax" @change="horafinUpdate()" >
        </div>
         <div class="form-group">
            <label class="col-form-label"> Fin Refrigerio  </label>
                <input type="time" v-model="FinRefrigerio" class="form-control" disabled >
        </div>
       
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="NuevoRefrigerio()" >Guardar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isNuevoHorario = false"> Cancelar</button>
      </div>
    </div>
    
</ModalPeque> 
<ModalMediano v-show="ModalMediano.isVerHorarios" :modalmediano="ModalMediano">  
    <div class="col-md-12" style="float: left;">
      
         <table class="table table-hover table-responsive" style="margin-top: 15px;float: left;"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                    
                      <th >Nombre</th>
                      <th >Inicio</th>
                      <th >Fin</th>
                      <th >Quitar</th>
                     

                   
                     
                    </tr>
                  </thead>
                  
                   <tbody v-for="(item, index) in ListaRefrigerios"   v-bind:key="item" v-bind:index="index" >
                    <tr >
                      <td >{{item.Nombre}}</td>
                      <td >{{item.IniRefrigerio}}</td>
                      <td >{{item.FinRefrigerio}}</td>
                        <td >
                          <button type="button" @click="Eliminar()" 
                          style="margin-left:5px;background: none;border: none;" ><i class="fas fa-times" style="color:red"></i></button>
                      </td>
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                
    </div>
     
</ModalMediano> 
<ModalPeque v-show="ModalPeque.isEliminarRefrigerio" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group" style="text-align: center;">
            <label class="col-form-label"> ¿Está seguro de eliminar el refrigerio? </label>
        </div>
        
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EliminarRefrigerio()" >Aceptar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isEliminarRefrigerio = false"> Cancelar</button>
      </div>
    </div>
</ModalPeque>
    <div class="overlay-wrapper"  v-if="load">
        <div class="overlay" style="flex-direction: column;">
            <i class="spinner-border"></i>
            <div class="text-bold pt-2">Cargando...</div>
        </div>
    </div>
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      Nombre:'',
      ListaTurnos:[],
      ListaRegistro:[],
      NombreRegistro:[],
      Horarios:[],
      HoraIngresoRegistro:"",
      HoraSalidaRegistro:"",
      ToleranciaRegistro:"",
      TurnosRegistro:-1,
      RefrigerioRegistro:"",
      Turnos:-1,
      load:false,
      CheckLunes : 0,
      CheckMartes: 0,
      CheckMiercoles: 0,
      CheckJueves: 0,
      CheckViernes: 0,
      CheckSabado: 0,
      CheckDomingo: 0,
      horarioselecionado : [],
      selecionadoregistro:[],
      refrigerioseleccionado:[],
      selecionado : [],
      ListaRefrigerios:[],
      Codigo:0,
      InicioRefrigerio:"",
      horafinmin:"",
      horainiciomax:"",
      FinRefrigerio:"",
      NombreGrupo:"",
      ModalPeque : {
        isEliminarHorarios : false,
        isNuevoHorario:false,
        isEliminarRefrigerio:false,
      },
      ModalMediano : {
        isVerHorarios : false,
      }, 
    };
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
   
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=19", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaTurnos = response.data.oListaParametros;
        })

  },
  methods: {
    Guardar(){
    var nuevohorarios = "";
    console.log(this.Horarios)
    this.Horarios.forEach((el) => {
        el.Refrigerios.forEach((rev) => {
          
            nuevohorarios +=
              "~"+
              rev.Codigo +"|"+
              rev.Nombre+"|"+
              rev.IniRefrigerio +"|"+
              rev.FinRefrigerio;
              
        
        });
      });
       const datarefrigerios = nuevohorarios.substring(1);
       console.log(datarefrigerios)
      var nuevoentsal = "";
      this.Horarios.forEach((el) => {
              nuevoentsal +=
                "~"+
                el.Codigo +"|"+
                el.HoraIngreso +"|"+
                el.HoraSalida +"|"+
                el.Refrigerio +"|"+
                el.Lunes +"|"+
                el.Martes +"|"+
                el.Miercoles +"|"+
                el.Jueves +"|"+
                el.Viernes +"|"+
                el.Sabado +"|"+
                el.Domingo;
        });
        const dataentrasal = nuevoentsal.substring(1);
        console.log(dataentrasal)
        var nuevogeneral = "";
        var codigo = '0';
                nuevogeneral +=
                  codigo +"|"+
                  this.NombreRegistro +"|"+
                  this.TurnosRegistro +"|"+
                  this.ToleranciaRegistro;

   
          console.log(nuevogeneral)

      let gestion = this.$store.state.menu;
      var bodyFormData = new FormData();
      bodyFormData.append("sData1 ", nuevogeneral);
      bodyFormData.append("sData2", dataentrasal);
      bodyFormData.append("sData3", datarefrigerios);
      this.axios.post(gestion + "/NuevoHorario", bodyFormData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          }
          })
          .then((response) => {
          const data_res = response.data.satisfactorio;
          this.load=false;
          if (data_res == true) { 
          //this.$store.state.message = true;
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Se agregó un nuevo horario con éxito',
            icon: 'success',
          
          });  
          this.$router.push("busqueda-horarios");
          }
          else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'error',
          
          });  
          }
          
        });


          //this.$store.state.message = true;
    },
    Eliminar(item){
    this.ModalPeque.isEliminarRefrigerio = true;
    this.selecionado = item;
 
    this.ModalPeque.titulo="Eliminar Refrigerio"

    },
    Quitar(item, horario){
    this.selecionado = item;
    this.horarioselecionado = horario
    this.ModalPeque.isEliminarHorarios = true;
    this.ModalPeque.titulo="Eliminar Horario"
    },
    AgregarRegistro(item){
    this.selecionadoregistro = item;
    this.refrigerioseleccionado = item.Refrigerio;
    this.ModalPeque.isNuevoHorario = true;
    this.ModalPeque.titulo="Nuevo Grupo Refrigerio";
    this.InicioRefrigerio = "";
    this.FinRefrigerio = "";
    this.NombreGrupo="";
    },
    VerRegistro(item, horariosdata){
    this.selecionado = item;
    this.selecionadoregistro =  horariosdata;
    this.ListaRefrigerios = item.Refrigerios;
    this.ModalMediano.isVerHorarios = true;
    this.ModalMediano.titulo="Lista de Refrigerio Agregados ";
    },
    NuevoRefrigerio(){
    const Data = {
        Codigo: this.selecionadoregistro.Codigo,
        IniRefrigerio: this.InicioRefrigerio,
        FinRefrigerio: this.FinRefrigerio,
        Nombre: this.NombreGrupo,
    };
    this.selecionadoregistro.Refrigerios.push(Data)
     this.ModalPeque.isNuevoHorario = false;
  
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Se agregó nuevo horario de refrigerio',
          icon: 'success',
          
          }); 
    },
    horafinUpdate(){
    var minutos = this.refrigerioseleccionado;
    let tiempo;
    tiempo = new Date("2000-01-01T" + this.InicioRefrigerio + ":00Z");
    tiempo.setMinutes(tiempo.getMinutes() + minutos);
    this.FinRefrigerio =  tiempo.toISOString().substr(11, 5);
    
    },
    
    EliminarRefrigerio(){
    
    var listahorarios =  this.ListaRefrigerios;
    listahorarios.splice(this.selecionado,1);
    

    this.ModalPeque.isEliminarRefrigerio = false;
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'se eliminó el registo',
          icon: 'success',
          
          }); 

    },
    EliminarHorarios(){
 
    var item = this.selecionado;
    var listahorarios =  this.Horarios;
    
    listahorarios.splice(item,1);
    

    
    this.ModalPeque.isEliminarHorarios = false;
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'se eliminó el registo',
          icon: 'success',
          
          }); 

    },
    Agregar(){
    if(this.HoraIngresoRegistro == ""  ||
    this.RefrigerioRegistro === "" || this.RefrigerioRegistro < 0 ||
    this.HoraSalidaRegistro == "" ||  this.CheckLunes == false &&  this.CheckMartes == false
    &&  this.CheckMiercoles == false &&  this.CheckJueves == false &&  this.CheckViernes == false
    &&  this.CheckSabado == false &&  this.CheckDomingo == false  ){
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Debe llenar todo los campos de Entras y Salidas',
          icon: 'error',
          
    }); 
    return
    }
    var CodigoNuevo = this.Codigo + 1;
    this.Codigo = CodigoNuevo;
    

    const Lunes = (this.CheckLunes) ? 1 : 0;
    const Martes = (this.CheckMartes) ? 1 : 0;
    const Miercoles = (this.CheckMiercoles) ? 1 : 0;
    const Jueves = (this.CheckJueves) ? 1 : 0;
    const Viernes = (this.CheckViernes) ? 1 : 0;
    const Sabado = (this.CheckSabado) ? 1 : 0;
    const Domingo = (this.CheckDomingo) ? 1 : 0;

    const Data = {
        Codigo: this.Codigo,
        HoraIngreso: this.HoraIngresoRegistro,
        HoraSalida: this.HoraSalidaRegistro,
        Refrigerio: this.RefrigerioRegistro,
        Refrigerios:[],
        Lunes: Lunes,
        Martes: Martes,
        Miercoles: Miercoles,
        Jueves: Jueves,
        Viernes: Viernes,
        Sabado: Sabado,
        Domingo: Domingo,
      };
    this.Horarios.push(Data);  
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'se agregó un nuevo horario',
          icon: 'success',
          
          }); 
    this.CheckLunes="";
    this.CheckMartes="";
    this.CheckMiercoles="";
    this.CheckJueves="";
    this.CheckViernes="";
    this.CheckSabado="";
    this.CheckDomingo="";
    this.HoraIngresoRegistro="";
    this.RefrigerioRegistro="";
    this.HoraSalidaRegistro="";
    


    },
    
   
    
    
   
        

  },
}
</script>
<style scoped>
.btn-table{
    margin: 0 5px;
    font-size: 14px;
}
</style>
